import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import RadioButton from '@bibliocommons/base-radio-button';
import TextField from '@bibliocommons/text-field';
import { userIdentityShape } from '@bibliocommons/bc-prop-types';

const CONTACT_PREFERENCES = {
  EMAIL: 'email',
  PHONE: 'phone'
};

const CONTACT_LABEL = {
  EMAIL: 'email_address',
  PHONE: 'telephone_number'
};

export default function ContactPreferenceField({
  currentUser,
  status,
  eventSettings,
  contactType,
  contactValue,
  onContactTypeChange,
  onContactValueChange
}) {
  const fieldLabel = contactType === CONTACT_PREFERENCES.PHONE ? CONTACT_LABEL.PHONE : CONTACT_LABEL.EMAIL;

  function handleFilter(type) {
    onContactTypeChange(type);
    if (type === CONTACT_PREFERENCES.EMAIL) {
      onContactValueChange(currentUser?.getIn(['userContact', 'email']) ?? '');
    } else {
      onContactValueChange('');
    }
  }

  function isPhoneOptionEnabled() {
    const registrationContactSettings = eventSettings?.get('registrationContactSettings');
    if (currentUser) return registrationContactSettings?.get('loggedInPhoneEnabled') ?? true;
    if (status === 'waitlist') return registrationContactSettings?.get('waitlistPhoneEnabled');
    return registrationContactSettings?.get('registrationPhoneEnabled');
  }

  const phoneOptionEnabled = isPhoneOptionEnabled();

  if (phoneOptionEnabled) {
    return (
      <div className="registration-form-contact">
        <div className="section-title">
          <FormattedMessage id="contact_preference" defaultMessage="Contact preference" />
        </div>
        <ul>
          <li key={CONTACT_PREFERENCES.EMAIL}>
            <RadioButton
              className="contact-radiobutton"
              id="email"
              name="contact-preference"
              label={<FormattedMessage id={CONTACT_PREFERENCES.EMAIL} defaultMessage="Email" />}
              checked={contactType === CONTACT_PREFERENCES.EMAIL}
              handleChange={() => handleFilter(CONTACT_PREFERENCES.EMAIL)}
            />
          </li>
          <li key={CONTACT_PREFERENCES.PHONE}>
            <RadioButton
              className="contact-radiobutton"
              id="telephone"
              name="contact-preference"
              label={<FormattedMessage id={CONTACT_PREFERENCES.PHONE} defaultMessage="Telephone" />}
              checked={contactType === CONTACT_PREFERENCES.PHONE}
              handleChange={() => handleFilter(CONTACT_PREFERENCES.PHONE)}
            />
          </li>
        </ul>
        <TextField
          className="contact"
          label={<FormattedMessage id={fieldLabel} defaultMessage="Email / Telephone" />}
          id="reg_contact_value"
          size="large"
          type={contactType === CONTACT_PREFERENCES.EMAIL ? CONTACT_PREFERENCES.EMAIL : 'text'}
          value={contactValue}
          onChange={onContactValueChange}
        />
      </div>
    );
  }

  return (
    <TextField
      className="contact"
      label={<FormattedMessage id={CONTACT_LABEL.EMAIL} defaultMessage="Email" />}
      id="reg_contact_value"
      size="large"
      type={contactType === CONTACT_PREFERENCES.EMAIL ? CONTACT_PREFERENCES.EMAIL : 'text'}
      value={contactValue}
      onChange={onContactValueChange}
    />
  );
}

ContactPreferenceField.propTypes = {
  currentUser: userIdentityShape,
  status: PropTypes.oneOf(['open', 'waitlist', 'closed']),
  eventSettings: ImmutablePropTypes.map,
  contactType: PropTypes.oneOf(Object.values(CONTACT_PREFERENCES)).isRequired,
  contactValue: PropTypes.string.isRequired,
  onContactTypeChange: PropTypes.func.isRequired,
  onContactValueChange: PropTypes.func.isRequired
};
